import { useCallback } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { UsePanelEquipoModeloSync } from "./UsePanelEquipoModeloSync";
import { Body1, Card, Title1 } from "@fluentui/react-components";
import { IEquipoModeloSync } from "../../../../../Interfaces/estadoEquipos/IEstadoEquipo";
import { Spinner } from "@fluentui/react";

export const PanelEquipoModeloSync=(props:IOpenPanel)=>{
    const usePanel = UsePanelEquipoModeloSync(props)
    const onRenderFooter = useCallback(
        () => (
          <>
            {usePanel.equipoModelosSync.length!=0 && (
            <PanelFooter
              texto="Guardar"
              texto2={"Salir"}
              //disableButton={disableForm}
              onClick={usePanel.SyncronizarEquipoModelos}
              onDismiss={usePanel.reset}
            />)}
          </>
        ),
        [usePanel.equipoModelosSync]
      );
   return(
    <PanelDrawer isOpen={props.isOpen} onDismiss={usePanel.reset} 
    onRenderFooter={onRenderFooter}
    textHeader={"Equipos Modelos a Sincronizar"} status={usePanel.status} mensaje={usePanel.mensaje} 
    loading={usePanel.loading}>
        <br/>
        {!usePanel.LoadingSincronizar ? (<>
        {usePanel.equipoModelosSync.length==0?(<Body1>
            Por el Momento, todas los equipoModelos ya han sido insertadas
        </Body1>):(
            <>
            {usePanel.equipoModelosSync.map((item:IEquipoModeloSync,index:number)=>(
               <Card>
               <Title1>{item.equipoModelo}</Title1>
               <Body1>Tipo: {item.tipoEquipo}</Body1>
               </Card>
            )
            )}
            </> 
        )}
        </>):(<Spinner></Spinner>)}
    </PanelDrawer>
   )
}